export { Text, TextProps, TextStylesKey, TextClasses } from './Text';
